<template>
	<div class="phone-login-view" :class="configStore.electronMode ? 'white-backgroup' : ''">
		<div class="decoration decoration-1"></div>
		<div class="decoration decoration-2"></div>
		<div class="decoration decoration-3"></div>
		<div class="content">
			<el-form class="form" :model="loginForm" status-icon :rules="rules"
				ref="loginForm" @keyup.enter.native="submitForm()" v-loading="loading" element-loading-text="正在验证...">
				<div class="title">
					<div>安全验证</div>
					<div class="subtitle">需要验证您的手机号以继续登录</div>
				</div>
				
				<el-form-item prop="phone">
					<el-input v-model="loginForm.phone" placeholder="手机号码" prefix-icon="el-icon-mobile-phone"
						maxlength="20"></el-input>
				</el-form-item>
				
				<el-form-item prop="code">
					<div class="send-code-bar">
						<el-input class="input" v-model="loginForm.code" placeholder="短信验证码" maxlength="6"
							prefix-icon="el-icon-key"></el-input>
						<div class="lock-text" v-if="phoneLockTime > 0">{{ `${phoneLockTime}秒后重新获取` }}</div>
						<el-button v-else class="code-btn" type="primary" plain size="mini"
							@click="onSendSmsCode">获取验证码</el-button>
					</div>
				</el-form-item>
				
				<el-button class="submit-btn" type="primary" @click="submitForm()">验证并登录</el-button>
				
				<div class="back-login">
					<router-link :to="{ path: '/login', query: { skipAuto: '1' } }">
						<i class="el-icon-back"></i>
						返回登录
					</router-link>
				</div>
			</el-form>
		</div>
		<icp></icp>
		<captcha-image ref="captchaRef"></captcha-image>
	</div>
</template>

<script>
import Icp from '../components/common/Icp.vue'
import CaptchaImage from '../components/common/CaptchaImage.vue';
import { getDeviceId, getDeviceModel } from '../utils/deviceUtils'
import { initYunxinAfterLogin } from '../api/loginHelper.js'

export default {
	name: "phoneLogin",
	components: {
		Icp,
		CaptchaImage
	},
	data() {
		var checkPhone = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入手机号码'));
			}
			const regex = /^1[3-9]\d{9}$/;
			if (!regex.test(value)) {
				return callback(new Error('手机号格式错误'));
			}
			callback();
		};
		var checkCode = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入验证码'));
			}
			if (value.length !== 6) {
				return callback(new Error('验证码为6位数字'));
			}
			callback();
		};
		return {
			loading: false,
			loginForm: {
				phone: '',
				code: '',
				terminal: this.$enums.TERMINAL_TYPE.WEB
			},
			rules: {
				phone: [{
					validator: checkPhone,
					trigger: 'blur'
				}],
				code: [{
					validator: checkCode,
					trigger: 'blur'
				}]
			},
			phoneLockTime: 0,
			phoneLockTimer: null
		};
	},
	methods: {
		submitForm() {
			this.$refs.loginForm.validate((valid) => {
				if (valid) {
					this.loading = true;
					
					// 获取设备信息
					const deviceId = getDeviceId();
					const deviceModel = getDeviceModel();
					
				// 构建登录数据
				const loginData = {
					phone: this.loginForm.phone,
					code: this.loginForm.code,
					terminal: this.loginForm.terminal,
					deviceId: deviceId,
					deviceModel: deviceModel
				};
					
					console.log('手机验证登录数据:', loginData);
					
					this.$http({
						url: "/login/phone",
						method: 'post',
						data: loginData
					}).then(async (data) => {
						await initYunxinAfterLogin(data);
						this.$message.success("验证成功，登录成功!");
						this.$router.push("/home/chat");
					}).catch((error) => {
						console.log("手机验证登录失败：", error);
										
						// 处理错误码 10008 - 需要设置二级密码
						if (error && error.code === 10008) {
							this.$message.warning("请先设置二级密码");
							// 从异常返回中获取 tempToken
							const tempToken = error.data || '';
							console.log('【调试】设置二级密码 tempToken:', tempToken);
							setTimeout(() => {
								this.$router.push({
									path: '/set-secondary-password',
									query: { tempToken: tempToken }
								});
							}, 1500);
							return;
						}
										
						// 处理错误码 10009 - 需要验证二级密码
						if (error && error.code === 10009) {
							this.$message.warning("请验证二级密码");
							// 从异常返回中获取 tempToken
							const tempToken = error.data || '';
							console.log('【调试】验证二级密码 tempToken:', tempToken);
							setTimeout(() => {
								this.$router.push({
									path: '/verify-secondary-password',
									query: { tempToken: tempToken }
								});
							}, 1500);
							return;
						}
					}).finally(() => {
						this.loading = false
					})
				}
			});
		},
		onSendSmsCode() {
			this.$refs.loginForm.validateField('phone', (valid) => {
				if (valid == '') {
					// 发短信前先验证验证码，防止盗刷
					this.$refs.captchaRef.open((id, code) => {
						// 60s内不允许再次发送
						this.phoneLockTime = 60;
						this.phoneLockTimer && clearInterval(this.phoneLockTimer);
						this.phoneLockTimer = setInterval(() => {
							this.phoneLockTime -= 1;
							if (this.phoneLockTime <= 0) {
								this.phoneLockTimer && clearInterval(this.phoneLockTimer);
							}
						}, 1000)
						// 发送短信
						let data = {
							phone: this.loginForm.phone,
							id: id,
							code: code
						}
						this.$http({
							url: "/captcha/sms/code",
							method: 'post',
							data: data
						}).then(() => {
							this.$message.success("验证码已发送至您的手机，请注意查收")
						}).catch(() => {
							// 发送失败时清除锁定
							this.phoneLockTime = 0;
							this.phoneLockTimer && clearInterval(this.phoneLockTimer);
						})
					});
				}
			})
		}
	},
	mounted() {
		// 加载配置
		this.configStore.loadConfig();
		// electron 窗口大小
		window.electronAPI && window.electronAPI.sendEvent('resize', {
			width: 410,
			height: 480,
			maximizable: false
		})
	},
	beforeDestroy() {
		// 清理定时器
		this.phoneLockTimer && clearInterval(this.phoneLockTimer);
	}
}
</script>

<style scoped lang="scss">
.phone-login-view {
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	display: flex;
	background: linear-gradient(135deg,
			#87adeb 0%,
			#8287ec 25%,
			#87adeb 50%,
			#898ee3 75%,
			#87adeb 100%);

	&.white-backgroup {
		background: white;
	}

	/* 装饰性元素 */
	.decoration {
		position: absolute;
		border-radius: 50%;
		background: rgba(255, 255, 255, 0.2);
	}

	.decoration-1 {
		width: 450px;
		height: 450px;
		background: linear-gradient(45deg, rgba(255, 255, 255, 0.3) 0%, rgba(200, 220, 240, 0.4) 100%);
		top: -250px;
		right: -100px;
		animation: float 16s infinite ease-in-out;
	}

	.decoration-2 {
		width: 400px;
		height: 400px;
		background: linear-gradient(135deg, rgba(200, 220, 240, 0.4) 0%, rgba(255, 255, 255, 0.3) 100%);
		bottom: -200px;
		left: -100px;
		animation: float 12s infinite ease-in-out;
	}

	.decoration-3 {
		width: 300px;
		height: 300px;
		background: linear-gradient(45deg, rgba(161, 196, 253, 0.3) 0%, rgba(194, 233, 251, 0.4) 100%);
		top: 50%;
		right: 50px;
		animation: float 8s infinite ease-in-out;
	}

	@keyframes float {

		0%,
		100% {
			transform: translateY(0) translateX(0);
		}

		25% {
			transform: translateY(-60px) translateX(30px);
		}

		50% {
			transform: translateY(30px) translateX(-45px);
		}

		75% {
			transform: translateY(-30px) translateX(-30px);
		}
	}

	.content {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;

		.form {
			width: 360px;
			min-height: 420px;
			padding: 25px;
			box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
			background: rgba(255, 255, 255, 0.95);
			backdrop-filter: blur(8px);
			border-radius: 3%;
			overflow: hidden;

			// 优化输入框样式
			::v-deep .el-form-item {
				margin-bottom: 20px;

				.el-input__inner {
					height: 50px;
					border-radius: 25px;
					border: 2px solid transparent;
					background: rgba(255, 255, 255, 0.9);
					box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
					transition: all 0.3s ease;
					padding-left: 50px;
					font-size: var(--im-font-size-large);

					&:focus {
						border-color: var(--im-color-primary);
						box-shadow: 0 8px 32px rgba(62, 69, 215, 0.15);
						transform: translateY(-2px);
					}

					&::placeholder {
						color: var(--im-text-color-light);
						font-size: var(--im-font-size);
					}
				}

				.el-input__prefix {
					left: 15px;

					.el-input__icon {
						color: var(--im-color-primary);
						font-size: 18px;
					}
				}
			}

			.title {
				text-align: center;
				margin: 20px 0 30px 0;

				> div:first-child {
					font-size: 24px;
					font-weight: 700;
					color: var(--im-color-primary);
					letter-spacing: 1px;
					line-height: 50px;
				}

				.subtitle {
					font-size: var(--im-font-size-small);
					color: var(--im-text-color-light);
					margin-top: 5px;
					line-height: 1.5;
				}
			}

			.send-code-bar {
				display: flex;
				align-items: center;
				gap: 8px;

				.input {
					flex: 1;
					min-width: 0;
				}

				.lock-text {
					font-size: 12px;
					color: var(--im-text-color-light);
					white-space: nowrap;
					flex-shrink: 0;
				}

				.code-btn {
					height: 36px;
					border-radius: 18px;
					font-size: 13px;
					padding: 0 16px;
					background: transparent;
					color: var(--im-color-primary);
					border: 1px solid var(--im-color-primary);
					transition: all 0.2s ease;

					&:hover {
						background: var(--im-color-primary-light-2);
						color: white;
						border-color: var(--im-color-primary);
					}
				}
			}

			.submit-btn {
				width: 100%;
				height: 46px;
				border-radius: 23px;
				border: none;
				background: linear-gradient(135deg, var(--im-color-primary), #5a61e8);
				color: white;
				font-size: var(--im-font-size-large);
				font-weight: 600;
				box-shadow: 0 8px 16px rgba(62, 69, 215, 0.3);
				transition: all 0.3s ease;
				letter-spacing: 5px;
				margin-top: 10px;

				&:hover {
					transform: translateY(-2px);
					box-shadow: 0 12px 40px rgba(62, 69, 215, 0.4);
				}

				&:active {
					transform: translateY(1px);
					box-shadow: 0 4px 16px rgba(62, 69, 215, 0.4);
				}
			}

			.back-login {
				display: flex;
				justify-content: center;
				line-height: 40px;
				text-align: center;
				margin-top: 20px;

				a {
					color: var(--im-text-color-light);
					text-decoration: none;
					font-size: var(--im-font-size);
					transition: all 0.3s ease;
					display: flex;
					align-items: center;
					gap: 5px;

					&:hover {
						color: var(--im-color-primary);
					}

					i {
						font-size: 16px;
					}
				}
			}
		}
	}
}
</style>
